import React, { useState, useEffect } from 'react';
import './knowledge.css';
import { FaCheckCircle, FaTimesCircle, FaChartBar, FaRedo, FaArrowRight, FaArrowLeft, FaAward } from 'react-icons/fa';
import { Link } from 'react-router-dom';


const testModules = [
  {
    id: 1,
    title: "Ocular Anatomy & Physiology",
    questions: [
      {
        question: "Which structure is responsible for the majority of the eye's refractive power?",
        options: ["Cornea", "Lens", "Vitreous", "Retina"],
        answer: 0
      },
      {
        question: "The ciliary body produces:",
        options: ["Aqueous humor", "Vitreous humor", "Tears", "Mucus"],
        answer: 0
      },
      {
        question: "Which retinal cells are responsible for color vision?",
        options: ["Rods", "Cones", "Ganglion cells", "Bipolar cells"],
        answer: 1
      },
      {
        question: "The fovea contains primarily:",
        options: ["Rods", "Cones", "Both rods and cones", "Neither rods nor cones"],
        answer: 1
      },
      {
        question: "Which cranial nerve innervates the lateral rectus muscle?",
        options: ["CN II", "CN III", "CN IV", "CN VI"],
        answer: 3
      },
      {
        question: "The tear film lipid layer is produced by:",
        options: ["Goblet cells", "Meibomian glands", "Lacrimal gland", "Wolfring glands"],
        answer: 1
      },
      {
        question: "Which structure has the highest concentration of mitochondria in the body?",
        options: ["Corneal epithelium", "Lens", "Retinal pigment epithelium", "Optic nerve"],
        answer: 2
      },
      {
        question: "The blood-retinal barrier is maintained by:",
        options: ["Tight junctions between retinal pigment epithelial cells", "Bruch's membrane", "Choroidal vessels", "Müller cells"],
        answer: 0
      }
    ]
  },
  {
    id: 2,
    title: "Optical Principles & Refraction-2",
    questions: [
      {
        question: "Which structure is responsible for the majority of the eye's refractive power?",
        options: ["Cornea", "Lens", "Vitreous", "Retina"],
        answer: 0
      },
      {
        question: "The ciliary body produces:",
        options: ["Aqueous humor", "Vitreous humor", "Tears", "Mucus"],
        answer: 0
      },
      {
        question: "Which retinal cells are responsible for color vision?",
        options: ["Rods", "Cones", "Ganglion cells", "Bipolar cells"],
        answer: 1
      },
      {
        question: "The fovea contains primarily:",
        options: ["Rods", "Cones", "Both rods and cones", "Neither rods nor cones"],
        answer: 1
      },
      {
        question: "Which cranial nerve innervates the lateral rectus muscle?",
        options: ["CN II", "CN III", "CN IV", "CN VI"],
        answer: 3
      },
      {
        question: "The tear film lipid layer is produced by:",
        options: ["Goblet cells", "Meibomian glands", "Lacrimal gland", "Wolfring glands"],
        answer: 1
      },
      {
        question: "Which structure has the highest concentration of mitochondria in the body?",
        options: ["Corneal epithelium", "Lens", "Retinal pigment epithelium", "Optic nerve"],
        answer: 2
      },
      {
        question: "The blood-retinal barrier is maintained by:",
        options: ["Tight junctions between retinal pigment epithelial cells", "Bruch's membrane", "Choroidal vessels", "Müller cells"],
        answer: 0
      }
    ]
  },
];

function KnowledgeQuest() {
  const [currentModule, setCurrentModule] = useState(0);
  const [currentStep, setCurrentStep] = useState(0); // 0 = questions, 1 = results
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [score, setScore] = useState(0);
  const [quizCompleted, setQuizCompleted] = useState(false);
  const [moduleCompleted, setModuleCompleted] = useState(Array(testModules.length).fill(false));

  // Initialize selectedOptions when module changes
  useEffect(() => {
    setSelectedOptions(Array(testModules[currentModule].questions.length).fill(null));
    setCurrentStep(0);
  }, [currentModule]);

  const handleOptionSelect = (questionIndex, optionIndex) => {
    const newSelectedOptions = [...selectedOptions];
    newSelectedOptions[questionIndex] = optionIndex;
    setSelectedOptions(newSelectedOptions);
  };

  const calculateScore = () => {
    let correct = 0;
    testModules[currentModule].questions.forEach((q, index) => {
      if (selectedOptions[index] === q.answer) {
        correct++;
      }
    });
    setScore(correct);
    return correct;
  };

  const handleSubmit = () => {
    const correct = calculateScore();
    const newModuleCompleted = [...moduleCompleted];
    newModuleCompleted[currentModule] = true;
    setModuleCompleted(newModuleCompleted);
    setCurrentStep(1);
  };

  const nextModule = () => {
    if (currentModule < testModules.length - 1) {
      setCurrentModule(currentModule + 1);
    } else {
      setQuizCompleted(true);
    }
  };

  const prevModule = () => {
    if (currentModule > 0) {
      setCurrentModule(currentModule - 1);
    }
  };

  const resetModule = () => {
    setSelectedOptions(Array(testModules[currentModule].questions.length).fill(null));
    setCurrentStep(0);
    const newModuleCompleted = [...moduleCompleted];
    newModuleCompleted[currentModule] = false;
    setModuleCompleted(newModuleCompleted);
  };

  const calculateOverallScore = () => {
    const totalQuestions = testModules.reduce((sum, module) => sum + module.questions.length, 0);
    const totalCorrect = moduleCompleted.reduce((sum, completed, index) => {
      return sum + (completed ? score : 0);
    }, 0);
    return Math.round((totalCorrect / totalQuestions) * 100);
  };

  const isPassed = () => {
    return calculateOverallScore() >= 80;
  };

  if (quizCompleted) {
    return (
      <div className="results-container">
        <div className={`results-card ${isPassed() ? 'passed' : 'failed'}`}>
          <div className="results-header">
            <h2>Knowledge Quest Results</h2>
            <div className="score-circle">
              <span>{calculateOverallScore()}%</span>
            </div>
            {isPassed() ? (
              <>
                <FaAward className="result-icon passed-icon" />
                <h3>Congratulations! You Passed</h3>
                <p>You have successfully completed the knowledge quest with a score of {calculateOverallScore()}%.</p>
              </>
            ) : (
              <>
                <FaTimesCircle className="result-icon failed-icon" />
                <h3>Assessment Not Passed</h3>
                <p>You scored {calculateOverallScore()}%. A minimum of 80% is required to renew your membership.</p>
              </>
            )}
          </div>

          <div className="detailed-results">
            <h4>Module Breakdown</h4>
            <div className="modules-stats">
              {testModules.map((module, index) => (
                <div key={module.id} className="module-stat">
                  <div className="module-stat-header">
                    <span className="module-name">{module.title}</span>
                    <span className="module-score">{moduleCompleted[index] ? score : 0}/{module.questions.length}</span>
                  </div>
                  <div className="progress-container">
                    <div 
                      className="progress-fill"
                      style={{ width: `${moduleCompleted[index] ? (score / module.questions.length) * 100 : 0}%` }}
                    ></div>
                  </div>
                </div>
              ))}
            </div>

            <div className="result-actions">
              {!isPassed() && (
                <button 
                  className="retry-button"
                  onClick={() => {
                    setQuizCompleted(false);
                    setCurrentModule(0);
                    setSelectedOptions(Array(testModules[0].questions.length).fill(null));
                    setModuleCompleted(Array(testModules.length).fill(false));
                  }}
                >
                  Retry Knowledge Quest
                </button>
              )}
              {isPassed() && (
                <Link to="/membership-renewal">
                  <button className="renew-button">
                    Proceed to Membership Renewal
                  </button>
                </Link>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="knowledge-quest-container">
      <div className="progress-tracker">
        <div className="modules-progress">
          {testModules.map((module, index) => (
            <div 
              key={module.id}
              className={`module-indicator ${index === currentModule ? 'active' : ''} ${moduleCompleted[index] ? 'completed' : ''}`}
              onClick={() => {
                if (moduleCompleted[index] || index < currentModule) {
                  setCurrentModule(index);
                }
              }}
            >
              <span>{index + 1}</span>
              {moduleCompleted[index] && <FaCheckCircle className="completed-icon" />}
            </div>
          ))}
        </div>
      </div>

      <div className="test-module">
        <h2 className="module-title">{testModules[currentModule].title}</h2>
        
        {currentStep === 0 ? (
          <>
            <div className="questions-grid">
              {testModules[currentModule].questions.map((q, qIndex) => (
                <div key={qIndex} className="question-card">
                  <h3 className="question-text">{qIndex + 1}. {q.question}</h3>
                  <div className="options-list">
                    {q.options.map((option, oIndex) => (
                      <div
                        key={oIndex}
                        className={`option ${selectedOptions[qIndex] === oIndex ? 'selected' : ''}`}
                        onClick={() => handleOptionSelect(qIndex, oIndex)}
                      >
                        <div className="option-letter">{String.fromCharCode(65 + oIndex)}</div>
                        <div className="option-text">{option}</div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>

            <div className="navigation-controls">
              <button 
                className="nav-button prev"
                onClick={prevModule}
                disabled={currentModule === 0}
              >
                <FaArrowLeft /> Previous Module
              </button>

              <button
                className="nav-button submit"
                onClick={handleSubmit}
                disabled={selectedOptions.some(opt => opt === null)}
              >
                Submit Answers
              </button>
            </div>
          </>
        ) : (
          <>
            <div className="module-results">
              <h3>Module Results</h3>
              <p>You scored {score} out of {testModules[currentModule].questions.length}.</p>
              
              <div className="questions-review">
                {testModules[currentModule].questions.map((q, qIndex) => {
                  const isCorrect = selectedOptions[qIndex] === q.answer;
                  return (
                    <div key={qIndex} className={`review-item ${isCorrect ? 'correct' : 'incorrect'}`}>
                      <div className="review-question">
                        <span>{qIndex + 1}. {q.question}</span>
                        {isCorrect ? (
                          <FaCheckCircle className="correct-icon" />
                        ) : (
                          <FaTimesCircle className="incorrect-icon" />
                        )}
                      </div>
                      <div className="review-answer">
                        Your answer: {selectedOptions[qIndex] !== null ? 
                          `${String.fromCharCode(65 + selectedOptions[qIndex])}: ${q.options[selectedOptions[qIndex]]}` : 
                          'Not answered'}
                        {!isCorrect && (
                          <span className="correct-answer">
                            Correct answer: {String.fromCharCode(65 + q.answer)}: {q.options[q.answer]}
                          </span>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            <div className="navigation-controls">
              <button 
                className="nav-button prev"
                onClick={() => setCurrentStep(0)}
              >
                <FaArrowLeft /> Back to Questions
              </button>

              {moduleCompleted[currentModule] && (
                <button
                  className="nav-button reset"
                  onClick={resetModule}
                >
                  <FaRedo /> Retake Module
                </button>
              )}

              <button
                className="nav-button next"
                onClick={nextModule}
              >
                {currentModule === testModules.length - 1 ? 'View Final Results' : 'Next Module'} <FaArrowRight />
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default KnowledgeQuest;